import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  InfiniteScrollCustomEvent,
  ModalController,
  Platform,
} from '@ionic/angular';
import { ProductCondition } from 'src/environments/environment';
import {
  AuthenticationStore,
  SearchResponse,
  TrendResponse,
} from '../stores/authentication.store';
import { CartDetail, CheckoutStore } from '../stores/checkout.store';
import {
  Product,
  ProductsResponse,
  ProductStore,
} from '../stores/product.store';

@Component({
  selector: 'app-search',
  templateUrl: './search.page.html',
  styleUrls: ['./search.page.scss'],
})
export class SearchPage implements OnInit {
  searchSkeleton: boolean = false;
  products: ProductsResponse = null;
  currentProductCondition: ProductCondition = ProductCondition.New;
  productCondition = ProductCondition;
  searchResult: string;
  addedCart: CartDetail;
  @Input() value: string = null;
  @Input() today_deals: number = null;
  page: number = 1;
  skeleton: boolean;
  productData: Array<Product>;
  trendingList: TrendResponse;
  searchList: SearchResponse;
  product_sort_status;
  category;
  delivery;
  pickUp;
  price_max;
  price_min;
  constructor(
    private productStore: ProductStore,
    private modalCtrl: ModalController,
    private router: Router,
    private checkoutStore: CheckoutStore,
    private auth: AuthenticationStore,
    public platform: Platform,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.platform.is('desktop')) {
      this.activatedRoute.params.subscribe((params) => {
        // Ionic creates this page after navigation ends, when
        // getCurrentNavigation() is already null; history.state still has it
        const state =
          this.router.getCurrentNavigation()?.extras?.state || history.state;
        if (state?.['searchValue']) {
          this.searchResult = state['searchValue'];
        }
        // params arrive asynchronously under Ionic, so load once the term is known
        this.page = 1;
        this.productList(null);
      });
    } else {
      this.searchResult = this.value;
      this.productList(null);
    }
    this.addedCart = this.checkoutStore.cartData;
  }

  ngOnInit() {}

  async searchProduct(event) {
    this.searchResult = event.target.value;
    this.productList(null);
    this.searchList = await this.auth.getRecentSearch({
      search_text: this.searchResult,
    });
    this.trendingList = await this.auth.getKeyWords({
      search_text: this.searchResult,
    });
  }

  selectSearch(value) {
    this.page = 1;
    this.productData = null;
    this.searchResult = value;
  }

  async deleteRecent(value) {
    this.searchList = await this.auth.getRecentSearch({
      search_text: value,
      delete: 1,
    });
  }

  async refreshProducts(event, ev: InfiniteScrollCustomEvent = null) {
    this.page = 1;
    this.productData = null;
    if (event) {
      this.product_sort_status = event?.product_sort_status;
      this.productList();
    }
  }

  async refreshFilterProducts(event, ev: InfiniteScrollCustomEvent = null) {
    this.page = 1;
    this.productData = null;
    if (event) {
      this.category = event?.category;
      this.delivery = event?.delivery;
      this.pickUp = event?.pickUp;
      this.price_max = event?.price_max;
      this.price_min = event?.price_min;
      this.today_deals = event?.today_deals;
      this.currentProductCondition = event?.condition;
      this.productList();
    }
  }

  async productList(ev: InfiniteScrollCustomEvent = null) {
    var params = {
      today_deals: this.today_deals ? this.today_deals : '',
      page: this.page,
      search_text: this.searchResult ? this.searchResult : '',
      condition: this.currentProductCondition,
      product_sort_status: this.product_sort_status
        ? this.product_sort_status
        : this.product_sort_status == 0
        ? 0
        : '',
      category: this.category ? this.category : '',
      delivery: this.delivery ? this.delivery : '',
      pickUp: this.pickUp ? this.pickUp : '',
      price_max: this.price_max ? this.price_max : '',
      price_min: this.price_min ? this.price_min : '',
      paginate: 12,
    };
    this.products = await this.productStore.getProducts(params);
    this.productData = ev
      ? this.productData.concat(this.products.data.product)
      : this.products.data.product;
    ev && ev.target.complete();
  }

  setCondition(productCondition: ProductCondition) {
    this.currentProductCondition = productCondition;
    this.productList(null);
  }

  redirect(id: any = null) {
    this.modalCtrl.dismiss();
    this.router.navigate([`/product/${id}`]);
  }

  myBag() {
    this.modalCtrl.dismiss();
    this.router.navigate(['/my-product-bag']);
  }

  close() {
    if (this.platform.is('mobile')) this.modalCtrl.dismiss();
    this.page = 1;
    this.productData = null;
    this.searchResult = '';
    this.productList();
  }

  onIonInfinite(ev) {
    this.page = this.page + 1;
    this.productList(ev);
  }
}
